export interface Movie {
  id: string;
  title: string;
  enTitle: string;
  cover: string;
  banner: string;
  category: '电影' | '美剧';
  genres: string[];
  year: number;
  rating: number;
  duration: string;
  region: string;
  director: string;
  cast: string[];
  updatedAt: string;
  tagline: string;
  summary: string;
  synopsis: string[];
  featured: boolean;
}

export const movies: Movie[] = [
  {
    id: 'american-taboo-4',
    title: '美国式禁忌4',
    enTitle: 'American Taboo IV',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20movie%20poster%20featuring%20a%20solitary%20silhouette%20against%20a%20rain%20soaked%20neon%20city%20street%20at%20midnight%2C%20moody%20low%20key%20lighting%20with%20deep%20blue%20shadows%20and%20warm%20amber%20highlights%2C%20fine%20film%20grain%20texture%2C%20minimalist%20editorial%20composition%20with%20generous%20negative%20space%2C%20premium%20cinema%20aesthetic%20background&width=600&height=900&seq=taboo-cover-main&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20brooding%20city%20skyline%20at%20dusk%20with%20lingering%20rain%20and%20reflective%20wet%20asphalt%2C%20deep%20indigo%20and%20charcoal%20tones%20cut%20by%20soft%20orange%20street%20lamps%2C%20dramatic%20atmospheric%20fog%2C%20anamorphic%20lens%20flares%2C%20high%20contrast%20moody%20thriller%20aesthetic%2C%20subtle%20film%20grain%2C%20negative%20space%20on%20the%20left%20for%20text&width=1920&height=1080&seq=taboo-hero-banner&orientation=landscape',
    category: '电影',
    genres: ['剧情', '悬疑', '惊悚'],
    year: 2025,
    rating: 8.7,
    duration: '128 分钟',
    region: '美国',
    director: '乔纳森·雷德福',
    cast: ['艾米莉亚·卡特', '马克·索伦森', '伊莎贝尔·雷诺', '丹尼尔·沃德'],
    updatedAt: '2026-10-12',
    tagline: '每一道禁忌背后，都藏着无法回头的真相。',
    summary:
      '当一桩尘封多年的家族旧案被重新翻开，三个看似毫无关联的人被迫走到一起。欲望、谎言与救赎交织成一张密不透风的网，《美国式禁忌4》以冷峻的镜头语言讲述一个关于秘密与代价的故事。',
    synopsis: [
      '在一个连绵阴雨的沿海城市，调查记者艾米莉亚接手了一桩被警方搁置十年的失踪案。案件的核心指向当地最显赫的家族，而所有线索最终都汇聚到一间早已废弃的临海别墅。',
      '随着调查深入，艾米莉亚发现自己的过去与案件有着意想不到的联系。她必须在自己坚守的真相与逐渐崩塌的信任之间做出抉择，而每一个被揭开秘密的人都将付出难以承受的代价。',
      '影片以克制而充满张力的叙事，探讨了家族、记忆与道德边界等主题，在悬疑外壳之下包裹着对人性深处灰色地带的追问。',
    ],
    featured: true,
  },
  {
    id: 'family-forbidden-zone',
    title: '家族禁区',
    enTitle: 'The Family Zone',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20series%20poster%20of%20an%20old%20Victorian%20mansion%20at%20night%20with%20a%20single%20lit%20window%2C%20cold%20blue%20moonlight%20mixing%20with%20warm%20interior%20glow%2C%20eerie%20atmosphere%2C%20fine%20film%20grain%2C%20minimalist%20composition%20with%20negative%20space%2C%20premium%20thriller%20aesthetic%20background&width=600&height=900&seq=taboo-cover-02&orientation=portrait',
    banner: '',
    category: '美剧',
    genres: ['悬疑', '剧情'],
    year: 2024,
    rating: 8.3,
    duration: '全 8 集',
    region: '美国',
    director: '海伦·斯图尔特',
    cast: ['格蕾丝·米勒', '罗伯特·凯恩', '索菲亚·林'],
    updatedAt: '2026-10-08',
    tagline: '家门之内，没有秘密是安全的。',
    summary: '一座继承而来的老宅，一本被刻意撕去数页的日记，让兄妹三人重新面对童年时被刻意遗忘的那个夜晚。',
    synopsis: [
      '母亲去世后，散落在各地的三兄妹回到位于乡间的家族老宅处理遗产。他们本以为这只是一次短暂的告别，却在阁楼里发现了母亲留下的一本残缺日记。',
      '日记中被撕去的几页，恰好记录着他们童年最不愿提起的那个夏天。随着记忆逐渐被唤醒，兄妹之间的信任开始动摇，每个人都可能在隐瞒着什么。',
      '《家族禁区》用缓慢推进的节奏与压抑的空间感，讲述了一个关于家庭秘密如何代代相传的故事。',
    ],
    featured: false,
  },
  {
    id: 'midnight-city',
    title: '午夜迷城',
    enTitle: 'Midnight Maze',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20noir%20movie%20poster%20of%20empty%20rain%20slicked%20downtown%20crossroads%20with%20towering%20glass%20buildings%2C%20deep%20teal%20and%20dusky%20blue%20palette%20with%20sparse%20orange%20traffic%20lights%2C%20heavy%20atmosphere%2C%20anamorphic%20cinematography%2C%20film%20grain%2C%20minimal%20editorial%20layout%20with%20negative%20space&width=600&height=900&seq=taboo-cover-03&orientation=portrait',
    banner: '',
    category: '电影',
    genres: ['犯罪', '悬疑'],
    year: 2025,
    rating: 8.1,
    duration: '116 分钟',
    region: '美国',
    director: '亚瑟·布莱克',
    cast: ['卢卡斯·格林', '娜奥米·斯通'],
    updatedAt: '2026-10-02',
    tagline: '城市从不入睡，谎言也是。',
    summary: '一名夜班出租车司机连续三个午夜搭载了同一位神秘乘客，而这三次行程正悄然拼凑出一宗悬案的真相。',
    synopsis: [
      '出租车司机卢卡斯习惯了城市的夜晚，也习惯了乘客们不愿说出口的故事。直到某个雨夜，一位沉默的女士连续三次出现在他的后座。',
      '三次行程、三个不同的目的地，却指向同一桩无人敢提的案子。卢卡斯意识到，自己或许早已被卷入了一场精心设计的棋局。',
      '影片以霓虹与阴影交织的视觉风格，描绘出一座不眠之城背后的孤独与算计。',
    ],
    featured: false,
  },
  {
    id: 'shadow-border',
    title: '边界之影',
    enTitle: 'Shadow Border',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20long%20empty%20highway%20stretching%20toward%20a%20stormy%20horizon%20with%20a%20single%20car%20headlight%2C%20muted%20blue%20gray%20sky%20with%20a%20streak%20of%20warm%20orange%20dusk%20light%2C%20melancholic%20mood%2C%20film%20grain%2C%20minimalist%20composition%20with%20wide%20negative%20space&width=600&height=900&seq=taboo-cover-04&orientation=portrait',
    banner: '',
    category: '美剧',
    genres: ['剧情', '惊悚'],
    year: 2024,
    rating: 7.9,
    duration: '全 10 集',
    region: '美国',
    director: '玛丽安·科尔',
    cast: ['伊森·布莱特', '克拉拉·维恩', '诺亚·邓肯'],
    updatedAt: '2026-09-27',
    tagline: '跨过那条线，就再也回不去了。',
    summary: '两名边境巡警在例行巡逻中发现了不该存在的东西，从此平静的小镇与他们的生活一同被彻底改写。',
    synopsis: [
      '在一条人烟稀少的边境公路上，巡警伊森与搭档克拉拉发现了一辆被遗弃的车辆，车内空无一人，却留下了一连串难解的线索。',
      '调查将他们引向小镇最隐秘的角落，也引向两人之间逐渐失控的信任危机。当职业操守与私人情感发生冲突，谁还能守住自己的边界。',
      '剧集以辽阔而苍凉的自然景观为背景，探讨了责任、忠诚与选择的重量。',
    ],
    featured: false,
  },
  {
    id: 'silent-block',
    title: '沉默街区',
    enTitle: 'Silent Block',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20crime%20poster%20of%20a%20quiet%20residential%20street%20at%20blue%20hour%20with%20shuttered%20windows%20and%20a%20lone%20street%20lamp%2C%20desaturated%20slate%20and%20indigo%20tones%20with%20a%20single%20warm%20orange%20glow%2C%20tense%20atmosphere%2C%20film%20grain%20texture%2C%20minimalist%20layout%20with%20negative%20space&width=600&height=900&seq=taboo-cover-05&orientation=portrait',
    banner: '',
    category: '电影',
    genres: ['悬疑', '剧情'],
    year: 2023,
    rating: 8.0,
    duration: '112 分钟',
    region: '美国',
    director: '保罗·汉密尔顿',
    cast: ['安娜·里斯', '托马斯·凯勒'],
    updatedAt: '2026-09-20',
    tagline: '最安静的地方，往往藏着最大的声音。',
    summary: '整条街的居民都听见了那声呼救，却没有任何人愿意承认——包括刚刚搬来的她。',
    synopsis: [
      '新住户安娜搬进了一条以安宁著称的街区，然而入住第一晚，她就听见了隔壁传来的求救声。',
      '报警之后，邻居们却一致表示什么都没发生。没有人愿意谈论那栋空置的房子，也没有人愿意提起三年前的旧事。',
      '安娜决定自己寻找答案，却发现沉默本身，就是这座街区最危险的规则。',
    ],
    featured: false,
  },
  {
    id: 'crimson-years',
    title: '血色年华',
    enTitle: 'Crimson Years',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20period%20drama%20poster%20of%20a%20vintage%20theater%20marquee%20glowing%20at%20night%20on%20a%20wet%20street%2C%20rich%20crimson%20and%20deep%20navy%20palette%20with%20golden%20warm%20accents%2C%20nostalgic%20melancholy%2C%20film%20grain%2C%20elegant%20minimal%20composition%20with%20negative%20space&width=600&height=900&seq=taboo-cover-06&orientation=portrait',
    banner: '',
    category: '美剧',
    genres: ['剧情', '年代'],
    year: 2023,
    rating: 7.8,
    duration: '全 6 集',
    region: '美国',
    director: '凯瑟琳·奥尔森',
    cast: ['詹姆斯·福特', '艾拉·莫里斯', '本·卡特'],
    updatedAt: '2026-09-14',
    tagline: '那段最好的年华，也最疼。',
    synopsis: ['上世纪八十年代的一座工业小城，一群年轻人在梦想与现实的夹缝中挣扎，而一场意外让所有人的人生轨迹从此分岔。'],
    summary: '一座即将关闭的剧院，一群不肯说再见的年轻人，和一段再也回不去的黄金年代。',
    featured: false,
  },
  {
    id: 'undercurrent',
    title: '暗流之下',
    enTitle: 'Undercurrent',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20poster%20of%20dark%20turbulent%20water%20surface%20seen%20from%20above%20with%20a%20submerged%20silhouette%20barely%20visible%2C%20deep%20navy%20and%20charcoal%20tones%20with%20a%20thin%20shaft%20of%20amber%20light%2C%20ominous%20atmosphere%2C%20film%20grain%2C%20minimal%20abstract%20composition&width=600&height=900&seq=taboo-cover-07&orientation=portrait',
    banner: '',
    category: '电影',
    genres: ['惊悚', '悬疑'],
    year: 2024,
    rating: 8.2,
    duration: '124 分钟',
    region: '美国',
    director: '维克多·兰姆',
    cast: ['奥利维亚·哈特', '朱利安·贝克'],
    updatedAt: '2026-09-08',
    tagline: '水面之下，才是真正的世界。',
    summary: '一次潜水事故后，幸存者开始怀疑：真正沉入水底的，究竟是人，还是他们共同的记忆。',
    synopsis: [
      '一群好友相约前往偏远的湖泊进行潜水度假，一场突如其来的事故让其中一人再也没能浮出水面。',
      '幸存者奥利维亚在康复过程中不断梦到水下的画面，而那些碎片化的记忆与官方调查结论越来越不符。',
      '为了弄清真相，她必须再次潜入那片幽暗的水域——以及自己不愿面对的过去。',
    ],
    featured: false,
  },
  {
    id: 'desire-city',
    title: '欲望之城',
    enTitle: 'Desire City',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20poster%20of%20a%20luxury%20penthouse%20window%20overlooking%20a%20glittering%20night%20skyline%2C%20cool%20blue%20and%20steel%20gray%20interior%20with%20warm%20orange%20bokeh%20lights%2C%20glamorous%20yet%20cold%20mood%2C%20film%20grain%2C%20sleek%20minimal%20composition&width=600&height=900&seq=taboo-cover-08&orientation=portrait',
    banner: '',
    category: '美剧',
    genres: ['剧情', '都市'],
    year: 2025,
    rating: 7.7,
    duration: '全 12 集',
    region: '美国',
    director: '大卫·斯特恩',
    cast: ['蕾切尔·金', '安德鲁·皮尔斯', '莉娜·瓦伦'],
    updatedAt: '2026-09-01',
    tagline: '这座城市给你一切，也拿走一切。',
    summary: '三个怀揣野心的年轻人闯入金融行业的顶端世界，很快就发现，这里的规则远比他们想象的残酷。',
    synopsis: [
      '在摩天大楼林立的金融中心，三位背景迥异的年轻人几乎同时踏入了这个以数字衡量一切的世界。',
      '他们渴望成功，也渴望被看见，却在一次次交易与背叛中逐渐模糊了自己最初的模样。',
      '《欲望之城》用锋利而克制的笔触，描绘了野心与代价之间那条细细的界线。',
    ],
    featured: false,
  },
  {
    id: 'lost-night',
    title: '迷途深夜',
    enTitle: 'Lost Night',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20mystery%20poster%20of%20a%20foggy%20forest%20road%20at%20night%20lit%20only%20by%20distant%20car%20headlights%2C%20deep%20blue%20mist%20with%20faint%20warm%20orange%20glow%2C%20disorienting%20atmosphere%2C%20film%20grain%2C%20minimal%20composition%20with%20heavy%20negative%20space&width=600&height=900&seq=taboo-cover-09&orientation=portrait',
    banner: '',
    category: '电影',
    genres: ['悬疑', '公路'],
    year: 2024,
    rating: 7.6,
    duration: '104 分钟',
    region: '美国',
    director: '萨姆·里德',
    cast: ['凯特·诺兰', '奥马尔·赛义德'],
    updatedAt: '2026-08-25',
    tagline: '有些路，走进去就出不来了。',
    summary: '一对陌生人在深夜的加油站相遇，决定共乘一程，却在这条没有尽头的路上逐渐分不清谁才是危险本身。',
    synopsis: [
      '深夜的加油站，两个素不相识的旅人因为各自的原因决定拼车同行。',
      '随着车辆驶入浓雾笼罩的林间公路，导航失灵、信号中断，两人之间的对话也开始变得危险而真实。',
      '影片用密闭空间与极简场景，营造出令人窒息的悬疑张力。',
    ],
    featured: false,
  },
  {
    id: 'seventh-night',
    title: '第七夜',
    enTitle: 'The Seventh Night',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20supernatural%20thriller%20poster%20of%20a%20flickering%20hotel%20corridor%20with%20numbered%20doors%20and%20a%20lone%20figure%2C%20cold%20indigo%20darkness%20pierced%20by%20warm%20amber%20sconce%20light%2C%20unsettling%20mood%2C%20film%20grain%2C%20symmetrical%20minimal%20composition&width=600&height=900&seq=taboo-cover-10&orientation=portrait',
    banner: '',
    category: '美剧',
    genres: ['惊悚', '悬疑'],
    year: 2024,
    rating: 7.9,
    duration: '全 7 集',
    region: '美国',
    director: '艾琳·福斯特',
    cast: ['马修·雷诺', '汉娜·布鲁克', '卡尔·门罗'],
    updatedAt: '2026-08-18',
    tagline: '第七个夜晚，真相会自己敲门。',
    summary: '一间老式旅馆的住客们相信，只要在这里连续住满七夜，就能见到自己最想见、也最害怕见到的人。',
    synopsis: [
      '在山间一间经营了近百年的老旅馆里，流传着一个奇怪的说法：连续住满七个夜晚的客人，会遇见自己最想见的人。',
      '一位前来调查的记者决定亲自验证这个传说，却发现每一位长住客都藏着一段不愿提起的往事。',
      '当第七个夜晚降临，她终于明白，有些相遇，代价远比想象中沉重。',
    ],
    featured: false,
  },
  {
    id: 'gray-zone',
    title: '灰色地带',
    enTitle: 'The Gray Zone',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20moral%20drama%20poster%20of%20an%20empty%20courtroom%20lit%20by%20a%20single%20high%20window%2C%20desaturated%20steel%20blue%20and%20warm%20beige%20tones%2C%20grave%20and%20contemplative%20mood%2C%20film%20grain%2C%20minimal%20geometric%20composition%20with%20negative%20space&width=600&height=900&seq=taboo-cover-11&orientation=portrait',
    banner: '',
    category: '电影',
    genres: ['剧情', '律政'],
    year: 2023,
    rating: 8.4,
    duration: '132 分钟',
    region: '美国',
    director: '菲利普·格兰特',
    cast: ['米兰达·肖', '艾伦·格雷', '塔玛拉·琼斯'],
    updatedAt: '2026-08-11',
    tagline: '法律是黑是白，还是我们都身处灰色之中？',
    summary: '一位理想主义的辩护律师接手了一桩几乎不可能赢的案子，却在过程中不断质问自己对与错的界限。',
    synopsis: [
      '年轻律师米兰达始终相信法律的公正，直到她接手了一桩被舆论提前定罪的案件。',
      '随着证据一点点浮现，她发现自己面对的不仅是法庭上的对手，还有内心关于正义与现实的激烈拉扯。',
      '影片通过一场漫长而克制的庭审，追问每个人心中那条模糊的灰色地带。',
    ],
    featured: false,
  },
  {
    id: 'soundless-confession',
    title: '无声告白',
    enTitle: 'A Soundless Confession',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20emotional%20drama%20poster%20of%20a%20quiet%20lakeside%20bench%20at%20dawn%20with%20still%20misty%20water%2C%20soft%20muted%20blue%20and%20gentle%20amber%20sunrise%20tones%2C%20introspective%20serene%20mood%2C%20film%20grain%2C%20minimal%20poetic%20composition%20with%20negative%20space&width=600&height=900&seq=taboo-cover-12&orientation=portrait',
    banner: '',
    category: '电影',
    genres: ['剧情', '家庭'],
    year: 2025,
    rating: 8.5,
    duration: '118 分钟',
    region: '美国',
    director: '露西亚·门德斯',
    cast: ['索菲·安德森', '格雷戈里·卢卡斯'],
    updatedAt: '2026-08-04',
    tagline: '有些话，说得越晚，越需要勇气。',
    summary: '一位常年在外工作的父亲在女儿成年那天回到湖边老屋，试图用一顿晚餐的时间，补上迟到二十年的道歉。',
    synopsis: [
      '父亲格雷戈里在外漂泊了二十年，直到女儿成年，他才第一次回到那座守着湖的老屋。',
      '一顿寻常的晚餐，成了父女二人这些年所有沉默与误解的出口。他们聊起过去，也终于愿意谈起那个谁都不愿先开口的名字。',
      '《无声告白》用细腻而克制的镜头，讲述了一段关于和解与原谅的温柔故事。',
    ],
    featured: true,
  },
];

export const featuredMovie = movies.find((m) => m.featured)!;